import React from "react";
import PropTypes from "prop-types";

const HolidayTable = ({ data }) => {
  if (!data || data.length === 0) {
    return <p>No holiday data found</p>;
  }

  return (
    <div
      style={{
        overflowX: "auto",
        border: "1px solid #ddd",
        borderRadius: 6,
        padding: 10,
        backgroundColor: "#fff"
      }}
    >
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          fontSize: 14,
          textAlign: "left"
        }}
      >
        <thead>
          <tr style={{ backgroundColor: "#f5f7f9" }}>
            <th
              style={{
                padding: "8px 10px",
                borderBottom: "1px solid #ddd"
              }}
            >
              Date
            </th>
            <th
              style={{
                padding: "8px 10px",
                borderBottom: "1px solid #ddd"
              }}
            >
              Occasion
            </th>
            <th
              style={{
                padding: "8px 10px",
                borderBottom: "1px solid #ddd"
              }}
            >
              Day
            </th>
          </tr>
        </thead>

        <tbody>
          {data.map((row, idx) => (
            <tr
              key={idx}
              style={{
                backgroundColor: idx % 2 === 0 ? "#fff" : "#fafafa"
              }}
            >
              <td
                style={{
                  padding: "8px 10px",
                  borderBottom: "1px solid #eee"
                }}
              >
                {row.Date}
              </td>
              <td
                style={{
                  padding: "8px 10px",
                  borderBottom: "1px solid #eee"
                }}
              >
                {row.Occasion}
              </td>
              <td
                style={{
                  padding: "8px 10px",
                  borderBottom: "1px solid #eee"
                }}
              >
                {row.Day}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

HolidayTable.propTypes = {
  data: PropTypes.array.isRequired
};

export default HolidayTable;
